<template>
  <span :for="id" class="btn-select">
    <select
      :id="id"
      v-model="value"
      class="selectbox"
      :name="name"
      @change="sendChangeEvent(trackingName)"
      @input="sendInputEvent(trackingName)"
      @focus="onFocus"
      @blur="onBlur"
      @click="sendClickEvent(trackingName)"
      @mousedown="sendMousedownEvent(trackingName)"
      @mouseover="sendMouseoverEvent(trackingName)"
      @mouseout="sendMouseoutEvent(trackingName)"
      @keydown="sendKeydownEvent(trackingName)"
      @keyup="sendKeyupEvent(trackingName)"
    >
      <slot></slot>
    </select>
  </span>
</template>

<script>
import {
  sendInputEvent,
  sendClickEvent,
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendKeydownEvent,
  sendKeyupEvent,
  sendChangeEvent,
  sendFocusEvent,
  sendBlurEvent,
} from "@/utils/FormEvent";
export default {
  name: "BtnSelect",
  props: {
    name: { type: String, default: "" },
    id: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    trackingName: { type: String, default: "" },
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup() {
    return {
      sendInputEvent,
      sendClickEvent,
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendKeydownEvent,
      sendKeyupEvent,
      sendChangeEvent,
      sendFocusEvent,
      sendBlurEvent,
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    onFocus(e) {
      this.sendFocusEvent(this.trackingName);
      this.$emit("focus", e);
    },
    onBlur(e) {
      this.sendBlurEvent(this.trackingName);
      this.$emit("blur", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.btn-select {
  position: relative;
  display: inline-block;
  color: $black;
  > select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0;
    margin: 0;
    background: $white;
    position: relative;
    padding: 7px 40px 7px 10px;
    border: 1px solid $secondary;
    border-radius: 0;
    font-size: 16px;
    line-height: 24px;
    &.selectbox {
      width: 100%;
      max-width: 360px;
    }
  }
  > select::-ms-expand {
    display: none;
  }
}
.btn-select::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  background: $white;
  height: 100%;
  width: 30px;
}
.btn-select::after {
  content: "";
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 9px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 6px 0 6px;
  border-color: $primary transparent transparent transparent;
}
</style>
